import type { StrapiLocale } from '@nuxtjs/strapi/dist/runtime/types'
import type { EmployeeTestimonial_Plain } from '@webamboos/admin'

export function useEmployeeTestimonials() {
  const { localeProperties } = useI18n()
  const { find } = useStrapi()

  const fetch = async () => {
    const { data } = await find('employee-testimonials', {
      locale: localeProperties.value.code as StrapiLocale,
      populate: ['portrait'],
    })

    const items = data as unknown as EmployeeTestimonial_Plain[]

    return items
  }

  return {
    fetch,
  }
}
